import { FunctionsHttpError } from '@supabase/supabase-js';

type StructuredErrorBody = {
  error?: unknown;
  code?: unknown;
  stage?: unknown;
};

function formatStructuredError(body: StructuredErrorBody | null | undefined): string | null {
  if (!body?.error) return null;
  let msg = String(body.error);
  const code = typeof body.code === 'string' && body.code ? body.code : null;
  const stage = typeof body.stage === 'string' && body.stage ? body.stage : null;
  if (code || stage) {
    const parts = [
      code ? `code: ${code}` : null,
      stage ? `stage: ${stage}` : null,
    ].filter(Boolean);
    msg = `${msg} (${parts.join(', ')})`;
  }
  return msg;
}

function isGenericFunctionsHttpMessage(message: string): boolean {
  return /non-2xx status code/i.test(message);
}

/** Pull the real `{ error }` body from a failed `functions.invoke` call. */
export async function invokeErrorMessage(
  error: unknown,
  data?: { error?: unknown; code?: unknown; stage?: unknown } | null,
): Promise<string | null> {
  const fromData = formatStructuredError(data);
  if (fromData) return fromData;
  if (error instanceof FunctionsHttpError && error.context) {
    try {
      const ctx = error.context as Response;
      const text =
        typeof ctx.clone === 'function' ? await ctx.clone().text() : await ctx.text();
      if (text) {
        try {
          const body = JSON.parse(text) as StructuredErrorBody;
          const formatted = formatStructuredError(body);
          if (formatted) return formatted;
        } catch {
          /* not JSON */
        }
      }
    } catch {
      /* ignore */
    }
  }
  if (error && typeof error === 'object' && 'message' in error && typeof (error as any).message === 'string') {
    const message = (error as any).message as string;
    if (isGenericFunctionsHttpMessage(message)) return null;
    return message;
  }
  return null;
}
